// extracted by mini-css-extract-plugin
module.exports = {"headerMargin":"cpf_headerMargin__sUtOw"};